const routes = [
  {
    index: true,
    label: 'Maria J. Diamantopoulou',
    path: '/',
  },
  // {
  //   label: 'Resume',
  //   path: '/resume',
  // },
  {
    label: 'Publications',
    path: '/publications',
  },
  {
    label: 'Stats',
    path: '/stats',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
